import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RosterMorePopoverPage } from './roster-more-popover.page';

const routes: Routes = [
  {
    path: '',
    component: RosterMorePopoverPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RosterMorePopoverPageRoutingModule {}
